import { render, staticRenderFns } from "./t_add.vue?vue&type=template&id=0e4063e4&scoped=true&"
import script from "./t_add.vue?vue&type=script&lang=js&"
export * from "./t_add.vue?vue&type=script&lang=js&"
import style0 from "./t_add.vue?vue&type=style&index=0&id=0e4063e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4063e4",
  null
  
)

export default component.exports